import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import Select from "../Common/Select";

import moment from "moment";
import firebase from "firebase/app";
import "firebase/auth";

const styles = theme => ({
	textField: {
		margin: 10,
		width: "calc(100% - 60px)"
	},
	select: {
		margin: 10,
		marginTop: 20
	}
});

class FormDialog extends React.Component {
	constructor() {
		super();
		this.state = {};
	}

	componentDidMount = () => {
		this.updateFields();
	};

	componentDidUpdate = prevProps => {
		if (prevProps.open !== this.props.open) {
			this.updateFields();
		}
	};

	updateFields = () => {
		const { fields } = this.props;
		var state = {};
		fields &&
			fields.forEach(field => {
				if (field.type === "date") {
					console.log(field);
					state[field.id] = moment()
						.add(field.daysToAdd || 0, "d")
						.format("YYYY-MM-DD");
				} else {
					state[field.id] = field.defaultValue || "";
				}
			});
		this.setState(state);
	};
	handleSave = event => {
		const { onClose } = this.props;
		console.log(this.state);
		var response = this.state;
		response.date = moment().format("YYYY-MM-DD");
		response.user = firebase.auth().currentUser.email;
		onClose(event, response);
	};

	handleChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	};

	render() {
		const { open, onClose, fields, title, message, classes } = this.props;
		return (
			<Dialog
				open={open}
				onClose={onClose}
				fullWidth
				aria-labelledby="form-dialog-title"
			>
				<CssBaseline />
				<DialogTitle id="form-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{message ? message : "Please fill in the following fields"}
					</DialogContentText>
					{fields &&
						fields.map(field => {
							if (field.type === "select") {
								return (
									<Select
										key={field.id}
										id={field.id}
										disabled={field.disabled}
										required={field.required}
										value={this.state[field.id]}
										onChange={this.handleChange}
										name={field.id}
										label={field.label}
										items={field.items}
										className={classes.select}
									/>
								);
							}
							// text / number / date
							return (
								<TextField
									className={classes.textField}
									key={field.id}
									disabled={field.disabled}
									required={field.required}
									variant="outlined"
									id={field.id}
									name={field.id}
									label={field.label}
									type={field.type}
									multiline={field.multiline ? true : false}
									rowsMax="4"
									rows={field.rows}
									onChange={this.handleChange}
									value={this.state[field.id]}
									fullWidth
								/>
							);
						})}
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose} color="primary">
						Cancel
					</Button>
					<Button onClick={this.handleSave} color="primary">
						Save
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

FormDialog.propTypes = {
	title: PropTypes.string.isRequired,
	fields: PropTypes.array,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};

export default withStyles(styles)(FormDialog);
